export const hotels = [{
  "_id": {
    "$oid": "6409890818aca046342fa2ed"
  },
  "name": "12:22 the stay",
  "address": "JAMRI KATAL NEAR DHAMANDA  GUEST HOUSE , TAPOVAN, TEHRI GARHWAL",
  "email": "1222thestay@gmail.com",
  "phone": "Mobile: 7895407533Ph: 05963-9627119733"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2ee"
  },
  "name": "a.r.resort",
  "address": "NA, GOUCHAR, CHAMOLI",
  "email": "arresortkameda@gmail.com",
  "phone": "Mobile: 8750713298Ph: 05942-235026"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2ef"
  },
  "name": "180 degree kanatal resort",
  "address": "7 km stone, chamba-mussorrie road, chopriyal gaon,, chamba, TEHRI GARHWAL",
  "email": "info@180resorts.com",
  "phone": "Mobile: 9897500532Ph: 0135-2627059",
  "website": "www.180resorts.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f0"
  },
  "name": "a s residency",
  "address": "Shivalic inclave Lane no 1 kargi chowk dehradun, Dehradun, Dehradun",
  "email": "a.sresidency777@gmail.com",
  "phone": "Mobile: 8868861996Ph: 248001-08868861996",
  "website": "www.asresidency.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f1"
  },
  "name": "aaa hotel and restaurant",
  "address": "VILL BHETSEM, POST NARAYANKOTI, RUDRAPRAYAG",
  "email": "shahkishorilal826@gmail.com",
  "phone": "Mobile: 9639645377Ph: 05962-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f2"
  },
  "name": "a.s. motels & resorts pvt. ltd",
  "address": "Haridwar-Rishikesh Road, near Dudhadhari Chowk, bhupatwala, Haridwar, Haridwar",
  "email": "kumartower@yahoo.com",
  "phone": "Mobile: 9837044993Ph: 248001-8958191697"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f3"
  },
  "name": "aadhira guest house",
  "address": "TEHSIL ROAD BAGESHWAR, BAGESHWAR, BAGESHWAR",
  "email": "ADVOCATEANILBHAKUNI4@gmail.com",
  "phone": "Mobile: 8393031422Ph: 01334-224328"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f4"
  },
  "name": "aadi badri guest house",
  "address": "5, laxman jhula street , rishikesh, pauri garhwal",
  "email": "aadi.badri@gmail.com",
  "phone": "Mobile: 9997028057Ph: 0135-9917076735"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f5"
  },
  "name": "aagan resort",
  "address": "CHAUKORI, BERINAG, pithoragarh",
  "email": "AAGANRESORT77@GMAIL.COM",
  "phone": "Mobile: 9412042455Ph: 0135-2440822"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f6"
  },
  "name": "aahana the corbett wilderness",
  "address": "Village - Sawaldey west, P.O shemalkhaliya, Ramnagar, Nainital",
  "email": "aahanaresort@gmail.com",
  "phone": "Mobile: 7088600021Ph: 05947-281240",
  "website": "www.aahanaresort.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f7"
  },
  "name": "aakash residency guest house",
  "address": "Khasra No.399, Near C.J. Complex, Jakhan, Rajpur Road, DEHRADUN, DEHRADUN",
  "email": "jainaakash456@gmail.com",
  "phone": "Mobile: 9760454054Ph: 0135 -2637000"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f8"
  },
  "name": "aar resort and spa",
  "address": "Paundha Pargana - Pachawa Dun, Near Doon International School River Side Campus, Dehradun, Dehradun",
  "email": "raithwan@gmail.com",
  "phone": "Mobile: 8859999669Ph: 248001-248001"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2f9"
  },
  "name": "aaradhey cottage",
  "address": "Gram Gajar Patti, Poorvi Agar, Tehsil Dhari, Nainital, Uttarakhand, 263132, Dhari, Nainital",
  "email": "tuffboy.11@gmail.com",
  "phone": "Mobile: 9999998548Ph: 248001-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2fa"
  },
  "name": "aananda guest house",
  "address": "jonk swargashram pauri garhwal, pauri garhwal, pauri garhwal",
  "email": "pundirdeepika98@gmail.com",
  "phone": "Mobile: 9897842506Ph: 135-9897842506"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2fb"
  },
  "name": "aaryan hotel and resort",
  "address": "BEL ROAD, KHOONIBARH, KOTDWAR, PAURI GARHWAL",
  "email": "virendrakala4404@gmail.com",
  "phone": "Mobile: 7895131875Ph: 01334-665400"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2fc"
  },
  "name": "aarogya residency",
  "address": "PLOT NO 4-A , INSIDE DEECON VALLEY , TAPOVAN, TEHRI GARHWAL",
  "email": "arogyaresidency001@gmail.com",
  "phone": "Mobile: 7500576009Ph: 0135-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2fd"
  },
  "name": "aaryavan resorts private limited",
  "address": "RAIWALA, RAIWALA, DEHRADUN",
  "email": "aryavanresort001@gmail.com",
  "phone": "Mobile: 6395651890Ph: 249403-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2fe"
  },
  "name": "aashirwaad valley view",
  "address": "KHUTANI, BHIMTAL, NAINITAL",
  "email": "www.Pankajkut@gmail.com",
  "phone": "Mobile: 7060196200Ph: 05947-271177"
},{
  "_id": {
    "$oid": "6409890818aca046342fa2ff"
  },
  "name": "aashirwad kunj",
  "address": "Jonk swarg ashram 247, Rishikesh, Pauri garhwal",
  "email": "Rudrarana26916@gmail.com",
  "phone": "Mobile: 7906525803Ph: 91-4532990"
},{
  "_id": {
    "$oid": "6409890818aca046342fa300"
  },
  "name": "aashirwad lodge",
  "address": "Ward-01, Bhatta Road, Vikasnagar, Dehradun",
  "email": "gulshanjoshi9@gmail.com",
  "phone": "Mobile: 9410360853Ph: 0135-2630202"
},{
  "_id": {
    "$oid": "6409890818aca046342fa301"
  },
  "name": "aashritha",
  "address": "kausani estate, kausani, bageshwar",
  "email": "aashrithakausani@gmail.com",
  "phone": "Mobile: 8126886255Ph: 05962-258016"
},{
  "_id": {
    "$oid": "6409890818aca046342fa302"
  },
  "name": "aastha guest house",
  "address": "0, LAXMANJHULLA TAPOVAN TALLA, TEHRI GARHWAL",
  "email": "bhandarianjali54@gmail.com",
  "phone": "Mobile: 8650580523Ph: 05942-8650580523"
},{
  "_id": {
    "$oid": "6409890818aca046342fa303"
  },
  "name": "aatithiyam resorts",
  "address": "Kalusiddh Road, Bhaniawala, Bhaniawala, Dehradun",
  "email": "aatithiyam@gmail.com",
  "phone": "Mobile: 7457831672Ph: 248140-7457831672"
},{
  "_id": {
    "$oid": "6409890818aca046342fa304"
  },
  "name": "aastha lodge hotel and restaurent",
  "address": "ANSUYA GATE MANDAL, TEHSIL-CHAMOLI, DISTRICT-CHAMOLI",
  "email": "bishtdigmbar@gmail.com",
  "phone": "Mobile: 9456562031Ph: 249410-9548110388"
},{
  "_id": {
    "$oid": "6409890818aca046342fa305"
  },
  "name": "aastha guest house",
  "address": "NEAR MEDICAL COLLEGE SRIKOT GANGANALI, SRINAGAR GARHWAL, PAURI GARHWAL",
  "email": "aaghouse2018@gmail.com",
  "phone": "Mobile: 8923048530Ph: 01364-233546"
},{
  "_id": {
    "$oid": "6409890818aca046342fa306"
  },
  "name": "aayush ganga tourist lodge",
  "address": "Koyal Ghati Haridwar Road, Ganga Vihar, Rishikesh , Dehradun",
  "email": "haraksinghfarswan@gmail.com",
  "phone": "Mobile: 8449921422Ph: 0135-2433144"
},{
  "_id": {
    "$oid": "6409890818aca046342fa307"
  },
  "name": "abhinandan guest house",
  "address": "Kailash Gate, Muni ki reti, Tehri garhwal",
  "email": "milinds@anandaspa.com",
  "phone": "Mobile: 9897890225Ph: 05947-284140"
},{
  "_id": {
    "$oid": "6409890818aca046342fa308"
  },
  "name": "aawa",
  "address": "BAIRGARH, PATTI UDAYPUR TALLA-1 TEHSIL YAMKESHWAR, BAIRGARH,, Pauri",
  "email": "aawadinesh@gmail.com",
  "phone": "Mobile: 8126202021Ph: 263132-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa309"
  },
  "name": "aananda lodge",
  "address": "LOHAJUNG, MUNDOLI,, TEHSIL-THARALI,, DISTRICT-CHAMOLI.",
  "email": "advrameshkuniyal01@gmail.com",
  "phone": "Mobile: 9634806395Ph: 0135-2442762"
},{
  "_id": {
    "$oid": "6409890818aca046342fa30a"
  },
  "name": "abhinandan guest house",
  "address": "04- BAGHRADHORAN, SAHASTRADHARA, DEHRADUN, DEHRADUN",
  "email": "roshanchamoli51@gmail.com",
  "phone": "Mobile: 9837902661Ph: 249403-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa30b"
  },
  "name": "abhinandan residency",
  "address": "Rishikesh Road, Durga Chowk, Bhaniyawala, Dehradun, Dehradun",
  "email": "abhinandanresidency@gmail.com",
  "phone": "Mobile: 7500388882Ph: ---",
  "website": "www.abhinandanresidency.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa30c"
  },
  "name": "abhishek lodge",
  "address": "TCP market, joshimath, Chamoli",
  "email": "abhisheklodge@gmail.com",
  "phone": "Mobile: 7830132474Ph: 05942-236817"
},{
  "_id": {
    "$oid": "6409890818aca046342fa30d"
  },
  "name": "abhishek guest house",
  "address": "Guptkashi, Guptkashi, Guptkashi",
  "email": "abhishekgh1973@gmail.com",
  "phone": "Mobile: 8979030733Ph: 0135-2636000"
},{
  "_id": {
    "$oid": "6409890818aca046342fa30e"
  },
  "name": "accurate hotel",
  "address": "COMBINED BUS STAND, RISHIKESH, DEHRADUN",
  "email": "accuratehotel001@gmail.com",
  "phone": "Mobile: 9897732857Ph: 0135-9012987830"
},{
  "_id": {
    "$oid": "6409890818aca046342fa30f"
  },
  "name": "acron cottage",
  "address": "VILLAGE- PANGOOT, NAINITAL, NAINITAL",
  "email": "woodenparadies@gmail.com",
  "phone": "Mobile: 9557068855Ph: 0135-2632773"
},{
  "_id": {
    "$oid": "6409890818aca046342fa310"
  },
  "name": "adarsh guest house",
  "address": "70, GARUR, BAGESHWAR",
  "email": "ratanskharain@gmail.com",
  "phone": "Mobile: 7895078121Ph: 249203-249203 8279396078"
},{
  "_id": {
    "$oid": "6409890818aca046342fa311"
  },
  "name": "adhikari hotel and homestay",
  "address": "VILL - KADHOLI BHIKIYASAIN, PO - BHIKIYASAIN, TEHSIL - BHIKIYASAIN, ALMORA, ALMORA, ALMORA",
  "email": "dikambersingh1@gmail.com",
  "phone": "Mobile: 9627119733Ph: 05963-9627119733"
},{
  "_id": {
    "$oid": "6409890818aca046342fa312"
  },
  "name": "adarsh hotel",
  "address": "15, ALMORA, ALMORA",
  "email": "ncjoshi1979@gmail.com",
  "phone": "Mobile: 9411366231Ph: 05962-241000"
},{
  "_id": {
    "$oid": "6409890818aca046342fa313"
  },
  "name": "adhikari restorent kotdwara",
  "address": "KOTARIDHANG SANEH KOTDWARA, KOTDWARA, KOTDWARA",
  "email": "nathusinghadhakari@gmail.com",
  "phone": "Mobile: 9411181790Ph: 0135-2632497"
},{
  "_id": {
    "$oid": "6409890818aca046342fa314"
  },
  "name": "adventure retreet",
  "address": "01 mangoli , mangoli, nainital",
  "email": "yashsah@gmail.com",
  "phone": "Mobile: 9639053533Ph: 248001-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa315"
  },
  "name": "aero suites by mj hotels - a unit of js developers",
  "address": "khasra no-1621, jollygrant rishikesh, dehradun",
  "email": "aerosuites001@gmail.com",
  "phone": "Mobile: 7500066654Ph: 249201-248001"
},{
  "_id": {
    "$oid": "6409890818aca046342fa316"
  },
  "name": "adi kailash hotel dharchula",
  "address": "POST AND TEHSIL -DHARCHULA, PITHORAGARH, PITHORAGARH",
  "email": "poohoo11081978@gmail.com",
  "phone": "Mobile: 8979395076Ph: 262554-250188"
},{
  "_id": {
    "$oid": "6409890818aca046342fa317"
  },
  "name": "adventure guide welfare society traning center amritpur bhimtal",
  "address": "VILLAGE AMRITPUR BHIMTAL, BHIMTAL AMRITPUR, NAINITAL",
  "email": "d.martolia.81@gmail.com",
  "phone": "Mobile: 9639273333Ph: 0135-9639273333"
},{
  "_id": {
    "$oid": "6409890818aca046342fa318"
  },
  "name": "agrawal house",
  "address": "LAXMANJHULA, RISHIKESH, PAURI GARHWAL",
  "email": "pawananany@gmail.com",
  "phone": "Mobile: 9997033970Ph: 0135-2433435"
},{
  "_id": {
    "$oid": "6409890818aca046342fa319"
  },
  "name": "adventure inn",
  "address": "KODIYALA, KODIYALA, TEHRI GARHWAL",
  "email": "kparmar171@gmail.com",
  "phone": "Mobile: 7409441402Ph: 05946-8937016682"
},{
  "_id": {
    "$oid": "6409890818aca046342fa31a"
  },
  "name": "aita hotels and resorts private limited",
  "address": "AITA, DUGADDA, PAURI GARWHAL",
  "email": "aitahotelandresort@gmail.com",
  "phone": "Mobile: 8755846480Ph: 0135-2720596"
},{
  "_id": {
    "$oid": "6409890818aca046342fa31b"
  },
  "name": "alaknanda guest house",
  "address": "Govindghat, GOVINDGHAT, CHAMOLI",
  "email": "alaknandag16@gmail.com",
  "phone": "Mobile: 9412936360Ph: 01378-262977"
},{
  "_id": {
    "$oid": "6409890818aca046342fa31c"
  },
  "name": "alaknanda inn",
  "address": "BADRINATH MARG, SRINAGAR GARHWAL, PAURI GARHWAL",
  "email": "VIKTHAKUR11@GMAIL.COM",
  "phone": "Mobile: 9719526929Ph: 0135-9899824413"
},{
  "_id": {
    "$oid": "6409890818aca046342fa31d"
  },
  "name": "akash geust house",
  "address": "dhanolti, dhanolti, tehri garhwal",
  "email": "cs56930@gmail.com",
  "phone": "Mobile: 9756438299Ph: 0135-2632925"
},{
  "_id": {
    "$oid": "6409890818aca046342fa31e"
  },
  "name": "alaknanda motel and restaurant",
  "address": "Sumerpur, Rudraprayag, Rudraprayag",
  "email": "alaknandamotel@gmail.com",
  "phone": "Mobile: 7060216704Ph: 0135-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa31f"
  },
  "name": "alaya resorts & spa a unit of kyari jungle resort",
  "address": "village kyari kham, Ramnagar, Nainital",
  "email": "nicky2284@gmail.com",
  "phone": "Mobile: 8279659132Ph: 0135-8279659132",
  "website": "www.alayaresorts.coom"
},{
  "_id": {
    "$oid": "6409890818aca046342fa320"
  },
  "name": "alka hotel",
  "address": "THE MALL, NAINITAL, NAINITAL",
  "email": "vedpshah@gmail.com",
  "phone": "Mobile: 9756100000Ph: 05942-235220",
  "website": "alka.in"
},{
  "_id": {
    "$oid": "6409890818aca046342fa321"
  },
  "name": "alka hotel",
  "address": "Gau Ghat near Har ki puari, Haridwar, Haridwar",
  "email": "vpbatra1@gmail.com",
  "phone": "Mobile: 9411165585Ph: 01334-228244"
},{
  "_id": {
    "$oid": "6409890818aca046342fa322"
  },
  "name": "albert lodge and cottage",
  "address": "ALBERT LODGE AND COTTAGE ESTATE,CHANDALGARHI, MUSSOORIE, DEHRADUN",
  "email": "NEGIMADDY3@GMAIL.COM",
  "phone": "Mobile: 8979848676Ph: 263139-248001"
},{
  "_id": {
    "$oid": "6409890818aca046342fa323"
  },
  "name": "all weather hotel and restaurant",
  "address": "Vill- Khola sunar po-barakote distt- champawat, Lohaghat, champawat",
  "email": "yatinverma8998@gmai.com",
  "phone": "Mobile: 7078244977Ph: 00-00"
},{
  "_id": {
    "$oid": "6409890818aca046342fa324"
  },
  "name": "allure inn",
  "address": "Kailash Tower, Near Patanjali Store, Tikonia,, Haldwani, Nainital",
  "email": "allureinn.haldwani@gmail.com",
  "phone": "Mobile: 9358194124Ph: 0135-09358194124"
},{
  "_id": {
    "$oid": "6409890818aca046342fa325"
  },
  "name": "aloha on the ganges",
  "address": "GHUGHTYANI TALLI BADRINATH ROAD NARANDERNAGAR DIST, RISHIKESH, TEHARI",
  "email": "sanjay.srivastava@prasadheritage.com",
  "phone": "Mobile: 9719453434Ph: 0135-2442573",
  "website": "www.prasadheritage.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa326"
  },
  "name": "alpine lodge and restaurant",
  "address": "CHOPTA ROAD MANDAL, TEHSIL-CHAMOLI,, DISTRICT-CHAMOLI.",
  "email": "alpinemandal@gmail.com",
  "phone": "Mobile: 9997400858Ph: 0135-2631461",
  "website": "www.alpinemandal.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa327"
  },
  "name": "alpine rhapsody",
  "address": "Boobudham, PO Kalika (Ranikhet), RANIKHET, Almora",
  "email": "anandnaini5@gmail.com",
  "phone": "Mobile: 9456595102Ph: 05942-248413",
  "website": "https://www.alpinerhapsody.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa328"
  },
  "name": "amaay the corbett jungle resort (a unit of  khulbe hotels and resort)",
  "address": "VILL SAWALDEY PASCHIM, RAMNAGAR, Nainital, Uttarakhand, 244715, Ramnagar, Nainital",
  "email": "khulbe_bimal@yahoo.co.in",
  "phone": "Mobile: 7895604185Ph: 263641-09412363337"
},{
  "_id": {
    "$oid": "6409890818aca046342fa329"
  },
  "name": "aman palace",
  "address": "Nagrasu Rudraprayag, NAGRASU, Rudraprayage",
  "email": "amanpalace9@gmail.com",
  "phone": "Mobile: 9410125222Ph: 01376-9594970810"
},{
  "_id": {
    "$oid": "6409890818aca046342fa32a"
  },
  "name": "aman residency",
  "address": "chama, chamiyala, tehri garhwal",
  "email": "ranveerrana1972@gmail.com",
  "phone": "Mobile: 8937016682Ph: 05946-8937016682"
},{
  "_id": {
    "$oid": "6409890818aca046342fa32b"
  },
  "name": "amatra by the ganges u/o plhr hospitality pvt ltd/p.c. paul & sons",
  "address": "CHILA RANGE NAJIBABAD ROAD NEAR RAJAJI NATIONAL PARK SHYAMPUR NOAMABAD HARIDWAR, HARIDWAR, HARIDWAR",
  "email": "adua@v2ventures.io",
  "phone": "Mobile: 9711007307Ph: 0135-7351008801"
},{
  "_id": {
    "$oid": "6409890818aca046342fa32c"
  },
  "name": "alka hotel",
  "address": "gandhi chowk, RANIKHET, Almora",
  "email": "ranikhetalka@gmail.com",
  "phone": "Mobile: 9410311000Ph: 05966-220269"
},{
  "_id": {
    "$oid": "6409890818aca046342fa32d"
  },
  "name": "amaya resort",
  "address": "12, CHOPRIYAL GAON KANATAL, TEHRI GARHWAL",
  "email": "amayarwsort58@gmail.com",
  "phone": "Mobile: 8006063777Ph: 263642-9897525660"
},{
  "_id": {
    "$oid": "6409890818aca046342fa32e"
  },
  "name": "ambience guest house",
  "address": "gali happy school, ramanand marg, s.n.nagar, haridwar, haridwar",
  "email": "piyuesh_oberoi@hotmail.com",
  "phone": "Mobile: 9837061220Ph: N.a.-N.a."
},{
  "_id": {
    "$oid": "6409890818aca046342fa32f"
  },
  "name": "ambience hill",
  "address": "4 K, Bhumiyadhar, Bhowali Range, Nainital, Nainital, Uttarakhand, NAINITAL, NAINITAL",
  "email": "ambiencehillntl@gmail.com",
  "phone": "Mobile: 9654472213Ph: 263002-236007"
},{
  "_id": {
    "$oid": "6409890818aca046342fa330"
  },
  "name": "ambika guest house",
  "address": "NEAR BADRINATH ROAD SRIKOT GANGANALI SRINAGAR PAURI GARHWAL UK, SRINAGAR GARHWAL, PAURI GARHWAL",
  "email": "ambikaguesthouse74@gmail.com",
  "phone": "Mobile: 9410723640Ph: 01334 -265198"
},{
  "_id": {
    "$oid": "6409890818aca046342fa331"
  },
  "name": "ambika cottage",
  "address": "GHATTUGHAT, YAMKESHWAR, PAURIGARHWAL",
  "email": "gabar8332@gmail.com",
  "phone": "Mobile: 9410503514Ph: 0135-07251087087"
},{
  "_id": {
    "$oid": "6409890818aca046342fa332"
  },
  "name": "amit paying guest house",
  "address": "kausani, kausani, Bageshwar",
  "email": "rdamitguesthouse@gmail.com",
  "phone": "Mobile: 9410309451Ph: 05942-286173"
},{
  "_id": {
    "$oid": "6409890818aca046342fa333"
  },
  "name": "ambrosia resorts",
  "address": "12 MILE STONE, ROORKEE, HAIDWAR",
  "email": "hr@ambrosiasarovarportico.com",
  "phone": "Mobile: 9720107174Ph: 01334-398400",
  "website": "www.sarovarhotels.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa334"
  },
  "name": "amity guest house",
  "address": "Vill-Naul, Navkuchiyatal, Nainital",
  "email": "VinodBrijwasi42@gmail.com",
  "phone": "Mobile: 9627355977Ph: 05947-281240"
},{
  "_id": {
    "$oid": "6409890818aca046342fa335"
  },
  "name": "amore guest house",
  "address": "VILL- JONK, POST- SWARGASHRAM, RISHIKESH, PAURI GARHWAL",
  "email": "amoreguesthouse@gmail.com",
  "phone": "Mobile: 7351770384Ph: 0135-2740892"
},{
  "_id": {
    "$oid": "6409890818aca046342fa336"
  },
  "name": "amrit bhawan",
  "address": "Amrit Banaspati Co. Pvt. Ltd. , Amrit Bhawan, Sanyas Road, Kankhal, Haridwar, Haridwar",
  "email": "hello@amritbhawan.in",
  "phone": "Mobile: 9810012451Ph: 263633-0135-2485421/22",
  "website": "www.amritbhawan.in"
},{
  "_id": {
    "$oid": "6409890818aca046342fa337"
  },
  "name": "amit hotel",
  "address": "KEDARNATH ROAD, BADASU PHATA, RUDRAPRAYAG",
  "email": "abhisheks64524@gmail.com",
  "phone": "Mobile: 9759376231Ph: 244715-08743032100"
},{
  "_id": {
    "$oid": "6409890818aca046342fa338"
  },
  "name": "amit guest house",
  "address": "Tapovan Sarai, Badrinath Road, Tapovan, Tehri Garhwal",
  "email": "omrambaba@yahoo.com",
  "phone": "Mobile: 9412052754Ph: 01378-261681"
},{
  "_id": {
    "$oid": "6409890818aca046342fa339"
  },
  "name": "amrit ganga  by suman garg",
  "address": "Badrinath Road, Ghutiyani Village, Tehri",
  "email": "sgsumangarg7@gmail.com",
  "phone": "Mobile: 9897386581Ph: 05946-09811310960"
},{
  "_id": {
    "$oid": "6409890818aca046342fa33a"
  },
  "name": "amrit resort guest house",
  "address": "AMRIT RESORT, NEAR APOLLO INTERNATIONAL SCHOOL, SAHASTRADHARA ROAD, DEHRADUN, DEHRADUN, DEHRADUN",
  "email": "amritregency@gmail.com",
  "phone": "Mobile: 9412056392Ph: 05943-7900699991"
},{
  "_id": {
    "$oid": "6409890818aca046342fa33b"
  },
  "name": "amrit guest house",
  "address": "woldrof Hotel Compound , Nainital, Nainital",
  "email": "sejuluthra645@gmail.com",
  "phone": "Mobile: 8958191697Ph: 263001-8958191697"
},{
  "_id": {
    "$oid": "6409890818aca046342fa33c"
  },
  "name": "anand himalaya resort",
  "address": "CHANDAN NAGAR GHURDAURI PAURI GARHWAL, PAURI, PAURI",
  "email": "anandhimalaya09@gmail.com",
  "phone": "Mobile: 9520578766Ph: 0135-7579289248"
},{
  "_id": {
    "$oid": "6409890818aca046342fa33d"
  },
  "name": "anamika hotel",
  "address": "Kamlasan compount.Upper Mall.Nainital, Nainital, Nainital",
  "email": "uttaranchalfilmcity@gmail.com",
  "phone": "Mobile: 9412084094Ph: 05942-237194",
  "website": "www.anamikahotelsnainital.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa33e"
  },
  "name": "anand lok guest house",
  "address": "VILLAGE SIRASU,  P O MALA, PATTI TALLA DHANGU, PAURI GARHWAL",
  "email": "ANANDLOK@GMAIL.COM",
  "phone": "Mobile: 9711159170Ph: 05944-242715"
},{
  "_id": {
    "$oid": "6409890818aca046342fa33f"
  },
  "name": "anand niketan",
  "address": "Near Birla Ghat, Jodhamal Road, Haridwar, Haridwar",
  "email": "samparkgp@gmail.com",
  "phone": "Mobile: 9411744449Ph: 013342-24445",
  "website": "www.anandniketanharidwar.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa340"
  },
  "name": "anand niwas lodging house",
  "address": "THE MALL ROAD, TALLITAL, NAINITAL, NAINITAL",
  "email": "anandniwasntl@gmail.com",
  "phone": "Mobile: 9910401600Ph: 05942- 9720225678"
},{
  "_id": {
    "$oid": "6409890818aca046342fa341"
  },
  "name": "ananda guest house",
  "address": "JONK SWARGASHRAM, RISHIKESH, RISHIKESH, RISHIKESH",
  "email": "anandaguesthouse2@gmail.com",
  "phone": "Mobile: 9897842506Ph: 05943--9219558882"
},{
  "_id": {
    "$oid": "6409890818aca046342fa342"
  },
  "name": "anand lodge",
  "address": "Badrinath Marg, Srinagar Garhwal, SrinagarGarhwal, SrinagarGarhwal",
  "email": "apanwar.888@gmail.com",
  "phone": "Mobile: 9997067979Ph: 0135-2442382"
},{
  "_id": {
    "$oid": "6409890818aca046342fa344"
  },
  "name": "anand kashi hospitality llp",
  "address": "Gular Dogi, Rishikesh, Tehri Gharwal",
  "email": "accounts.e46@forestessentialsindia.com",
  "phone": "Mobile: 8791818240Ph: 0135-8791418240"
},{
  "_id": {
    "$oid": "6409890818aca046342fa345"
  },
  "name": "anandam heights resort",
  "address": "Village.- Matogi, P.O.- Madarsu, Teh.- Vikasnagar, Dehradun, VIKASNAGAR, Dehradun",
  "email": "Anandamheightsmatogi@gmail.com",
  "phone": "Mobile: 9810167949Ph: 249128-7253000919"
},{
  "_id": {
    "$oid": "6409890818aca046342fa346"
  },
  "name": "anandvan jungle resort",
  "address": "Neelkanth Road, Yamkeshwar, Pauri",
  "email": "info.anandvanresort@gmail.com",
  "phone": "Mobile: 9412021747Ph: 249201-248001",
  "website": "www.anandvanjungleresort.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa347"
  },
  "name": "ananta paradise",
  "address": "NEHRU MARG ASHUTOSH NAGAR, RISHIKESH, DEHRADUN",
  "email": "anantaparadise@gmail.com",
  "phone": "Mobile: 9897599780Ph: 249128-08077848901"
},{
  "_id": {
    "$oid": "6409890818aca046342fa348"
  },
  "name": "anant rasa a unit of lammergeier",
  "address": "VILLAGE SHYAHIDEVI, PO sITLAKHET, ALMORA",
  "email": "anantrasa@amritara.co.in",
  "phone": "Mobile: 8650000692Ph: 05942--8650000635",
  "website": "anantrasa.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa349"
  },
  "name": "anany resort",
  "address": "Village Bagar Malla Pangoot Tehsil and District Nainital, Nainital, Nainital",
  "email": "chandolatushar@gmail.com",
  "phone": "Mobile: 8860028809Ph: 0135-08506064804"
},{
  "_id": {
    "$oid": "6409890818aca046342fa34a"
  },
  "name": "anantrasa by aamod",
  "address": "VILL SHITLAKHET POST SHITLAKHET , ALMORA, ALMORA",
  "email": "bhashkarjoshi38@gmail.com",
  "phone": "Mobile: 7055000487Ph: 0135-9760077662"
},{
  "_id": {
    "$oid": "6409890818aca046342fa34b"
  },
  "name": "angels cottages",
  "address": "Kaul Village, Tok Jindal, Pokhrad, Nainital",
  "email": "angelbusinesscorporation@gmail.com",
  "phone": "Mobile: 9873079583Ph: 0135-2632410"
},{
  "_id": {
    "$oid": "6409890818aca046342fa34c"
  },
  "name": "anantum gateway resort",
  "address": "(A UNIT OF GOYAL GROUP OF HOTELS) KHASRA NO. 123, KHATUNI NO. 00019, PARGANA BHAVAR CHILKIYA, VILLAGE- MOTIPUR NEGI, RAMNAGAR, NAINITAL",
  "email": "goyalgroupofhotel@gmail.com",
  "phone": "Mobile: 9675066066Ph: 05962-"
},{
  "_id": {
    "$oid": "6409890818aca046342fa34d"
  },
  "name": "anexcy gmvn barkot",
  "address": "barkot, barkot, uttarkashi",
  "email": "anexcy1979@gmail.com",
  "phone": "Mobile: 9568006613Ph: 01375-224236",
  "website": "www.gmvnl.in"
},{
  "_id": {
    "$oid": "6409890818aca046342fa34e"
  },
  "name": "animal path resorts",
  "address": "55, Yamkeshwar, Pauri",
  "email": "bgboss923@gmail.com",
  "phone": "Mobile: 9411117800Ph: 0135-2442389"
},{
  "_id": {
    "$oid": "6409890818aca046342fa34f"
  },
  "name": "anju tourist lodge",
  "address": "NEAR BUS STAND MAIN MARKET, PUROLA, UTTARKASHI",
  "email": "prabhakaruccpainuly@gmail.com",
  "phone": "Mobile: 7895285156Ph: 226246-1376283014"
},{
  "_id": {
    "$oid": "6409890818aca046342fa350"
  },
  "name": "anjali tourist lodge",
  "address": "24, SILLI AUGSTYAMUNI, RUDRAPRAYAG",
  "email": "bngoswami69@gmail.com",
  "phone": "Mobile: 7500818122Ph: 0135-9639273333"
},{
  "_id": {
    "$oid": "6409890818aca046342fa351"
  },
  "name": "anmol county",
  "address": "GHASHIYAMADEV , SRINAGAR , PAURI GARHWAL",
  "email": "GUNJAN32323@GMAIL.COM",
  "phone": "Mobile: 9811259377Ph: 0135-2632773"
},{
  "_id": {
    "$oid": "6409890818aca046342fa352"
  },
  "name": "anna cafe guest house",
  "address": "VILL KIRMOLA, JONK, LAXMAN JHULA, PAURI GARHWAL",
  "email": "rakeshprajapati10772@gmail.com",
  "phone": "Mobile: 9557879360Ph: 0135-2437712"
},{
  "_id": {
    "$oid": "6409890818aca046342fa353"
  },
  "name": "annpurna guest house",
  "address": "MAIN SAHASTRADHARA, DEHRADUN, DEHRADUN",
  "email": "chauhan.1298@gmail.com",
  "phone": "Mobile: 9758915139Ph: 248001-09870902945"
},{
  "_id": {
    "$oid": "6409890818aca046342fa354"
  },
  "name": "anoda lauge",
  "address": "PADAMPUR MOTADHANG KOTDWARA, KOTDWARA, PAURI  GARHWAL",
  "email": "pushkarsinghbisht@gmail.com",
  "phone": "Mobile: 9410911525Ph: 0135-2436146"
},{
  "_id": {
    "$oid": "6409890818aca046342fa355"
  },
  "name": "anupam hotel",
  "address": "MALLITAL, NAINITAL, NAINITAL",
  "email": "sjagati52@gmail.com",
  "phone": "Mobile: 9411790593Ph: 05942-236394"
},{
  "_id": {
    "$oid": "6409890818aca046342fa356"
  },
  "name": "anurag hotel badasu",
  "address": "KEDARNATH ROAD BADASU  POST BADASU, RUDRAPRAYAG, RUDRAPRAYAG",
  "email": "kuldeepsingh190088@gmail.com",
  "phone": "Mobile: 8126874526Ph: 244715-08743032100"
},{
  "_id": {
    "$oid": "6409890818aca046342fa357"
  },
  "name": "antaram resort",
  "address": "Ghattughad, Yamkeshwar, Pauri",
  "email": "dhyani.akash@gmail.com",
  "phone": "Mobile: 9818155776Ph: 0135-07251087087",
  "website": "www.antaramresort.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa358"
  },
  "name": "anoop guest house",
  "address": "PHATA (MAIKHANDA), PHATA, RUDRAPRAYAG",
  "email": "anooptoursitguest@gmail.com",
  "phone": "Mobile: 9411155182Ph: 01346-250572"
},{
  "_id": {
    "$oid": "6409890818aca046342fa359"
  },
  "name": "apical resort",
  "address": "APICAL RESORT, JUNGLIAGAON, BHIMTAL, NAINITAL",
  "email": "apicalresort@gmail.com",
  "phone": "Mobile: 9997871944Ph: 0135 -2637000"
},{
  "_id": {
    "$oid": "6409890818aca046342fa35a"
  },
  "name": "anushri lodge",
  "address": "Ukhimath, Ukhimath, Rudraprayage",
  "email": "anushrilodge8@gmail.com",
  "phone": "Mobile: 9758071182Ph: 01375-224670",
  "website": "www.anushrilodge.com"
},{
  "_id": {
    "$oid": "6409890818aca046342fa35b"
  },
  "name": "apna ghar chaukori",
  "address": "CHAUKORI BERINAG, BERINAG, BERINAG",
  "email": "smartoliya123@gmail.com",
  "phone": "Mobile: 9458920379Ph: 0135-2431534"
},{
  "_id": {
    "$oid": "6409890818aca046342fa35c"
  },
  "name": "appu lodge",
  "address": "BADRINATH MARG, SRINAGAR GARHWAL, PAURI",
  "email": "DEEPAKRAJPUT2063@GMAIL.COM",
  "phone": "Mobile: 9410536904Ph: 05962-230081"
},{
  "_id": {
    "$oid": "6409890818aca046342fa35d"
  },
  "name": "apna guest house",
  "address": "56- JHANDA MOHALLA, DEHRADUN, DEHRADUN",
  "email": "glmalhotra@yahoo.com",
  "phone": "Mobile: 9410320163Ph: 05962-"
},]